import type { GuideBook } from "../types";

export const QUOTE_APPROVALS_GUIDES: GuideBook = {
  quote_approvals: {
    purpose:
      "Hàng chờ những bản báo giá doanh nghiệp cần người xét thêm trước khi gửi ra cho khách.",
    where: [
      'Đầu trang: tiêu đề "Duyệt báo giá".',
      'Ngay dưới là khối "Đang chờ duyệt" — con số cạnh tiêu đề là số bản đang nằm trong hàng chờ.',
      'Bên phải tiêu đề khối: hàng nút lọc, gồm "Mọi mức" và hai nút theo mức xét của bản.',
      "Mỗi bản là một thẻ. Góc trái trên thẻ là mã đơn — bấm thẳng vào mã là mở bản đó ra.",
      "Cạnh mã đơn là các nhãn nhỏ: mức xét, khách ký lần thứ mấy, và mức thiện chí nếu bản có ghi.",
      "Dưới mã đơn: tên khách và tên dự án, rồi một dòng chữ nhạt ghi cơ sở, giờ gửi và người gửi.",
      "Dưới cùng bên trái thẻ, nếu có, là danh sách gạch đầu dòng nói vì sao bản này phải qua tay người xét.",
      'Góc phải thẻ: tổng tiền của bản, dòng ưu đãi ngay dưới, và nút "Mở để xét".',
      'Hàng chờ rỗng thì giữa khối hiện dòng "Không có bản nào chờ duyệt".',
    ],
    howItWorks: [
      "Bản báo giá không tự đi qua đây. Phần lớn bản nằm trong mức người dựng tự quyết được thì gửi thẳng cho khách; chỉ bản chạm phải một trong mấy điều đã đặt sẵn mới rơi vào hàng chờ này.",
      'Vì sao một bản có mặt ở đây thì đọc ngay trên thẻ: mấy gạch đầu dòng dưới tên khách nói đúng lý do — ưu đãi quá mức, có dòng soạn riêng ngoài bảng giá, có dòng gõ giá tay, hay tặng một món bảng giá không có.',
      'Nhãn mức xét cho biết bản này đang chờ ở nấc nào, nên lọc theo mức là cách nhanh nhất tìm phần của mình. Một bản chỉ chờ ở MỘT nấc.',
      'Có bản mang nhãn "Tự quyết" mà vẫn nằm đây: mức ưu đãi của nó không vượt gì cả, nhưng nó có dòng ngoài bảng giá nên vẫn phải có người nhìn qua.',
      "Hàng chờ tự cập nhật theo việc thật: bên dựng bản bấm gửi là bản hiện ở đây, bạn chốt xong là bản rời khỏi danh sách ngay lần tải kế tiếp.",
      "Bản xếp theo thứ tự gửi, bản chờ lâu nhất nằm trên cùng — cứ làm từ trên xuống là không ai bị quên.",
      "Bấm mã đơn hay bấm nút bên phải đều mở đúng một chỗ: thẻ Báo giá trong chi tiết đơn. Mọi việc xem kỹ và chốt đều làm ở đó; màn này chỉ là danh sách, không chốt được từ đây.",
      "Bản để quá ngày hết hạn ưu đãi vẫn nằm nguyên trong hàng chờ — hết hạn không làm bản biến mất, và cũng không đẩy bản ra cho khách.",
      "Danh sách chỉ hiện bản của những cơ sở bạn xem được, nên hai người cùng mở màn này có thể thấy số bản khác nhau. Đó là bình thường.",
    ],
    statuses: [
      {
        label: "Tự quyết",
        meaning:
          "Nhãn mức xét: phần ưu đãi của bản không vượt mức nào. Bản vẫn chờ vì lý do khác, đọc mấy gạch đầu dòng trên thẻ.",
      },
      {
        label: "Nhãn mức xét màu đậm",
        meaning: "Bản chạm nấc cao nhất — xem kỹ hơn, và đừng chốt thay người đứng ở nấc đó.",
      },
      {
        label: "khách lần …",
        meaning: "Khách này ký với mình lần thứ mấy. Không có nhãn nghĩa là bản chưa ghi con số đó.",
      },
      {
        label: "thiện chí thấp / vừa / cao",
        meaning:
          "Mức thiện chí mà bên dựng bản tự đánh giá về khách. Chỉ là lời khai để bạn tham khảo, không phải số máy tính ra.",
      },
      {
        label: "Không có bản nào chờ duyệt",
        meaning: "Hàng chờ đang rỗng — không phải lỗi, cũng không phải bạn nhìn nhầm chỗ.",
      },
    ],
    blocks: [
      {
        for: ["sale", "lead"],
        title: "Việc của bạn trên trang này",
        steps: [
          "Mở trang mỗi đầu buổi như mở hộp thư: bản nằm đây là có người đang đợi bạn, không phải việc để dành.",
          'Bấm "Mọi mức" trước để thấy toàn bộ hàng chờ, rồi lọc về nấc của mình nếu danh sách dài.',
          "Làm từ trên xuống — bản trên cùng là bản gửi sớm nhất.",
          "Đọc ba thứ ngay trên thẻ trước khi mở: lý do bản phải chờ, tổng tiền, và dòng ưu đãi bên phải.",
          'Bấm "Mở để xét" để sang thẻ Báo giá của đơn đó; ở đó mới có đủ bảng chi tiết và hai nút chốt.',
          "Chốt xong thì quay lại đây, bản vừa xử lý sẽ không còn trong danh sách.",
          "Bản nằm ở nấc cao hơn phần mình thì để nguyên, đừng mở ra chốt hộ — người ở nấc đó cũng đang nhìn cùng danh sách này.",
        ],
        troubles: [
          "Hàng chờ trống trong khi có người báo vừa gửi bản: tải lại trang; vẫn trống thì bản đó thuộc cơ sở bạn không xem được, nhờ quản lý trực tiếp xem giúp.",
          'Màn báo "Chưa đọc được hàng chờ": tải lại trang, vẫn vậy thì báo kỹ thuật — đừng đoán là không có bản nào.',
          "Bấm mở ra mà thẻ Báo giá không còn nút chốt: bản vừa được xử lý xong ở nơi khác, hoặc bản đã bị sửa và đang chờ lại. Quay ra danh sách xem còn không.",
          "Thấy một mã lạ thay vì câu tiếng Việt ở phần lý do: báo kỹ thuật, đừng tự đoán nghĩa của mã.",
          "Bản đã xử lý mà vẫn còn trong danh sách: tải lại trang một lần; còn nữa thì bản đã bị sửa và quay lại chờ, mở ra đọc lại lý do.",
        ],
      },
      {
        for: ["exec"],
        title: "Trang này cho bạn thấy gì",
        steps: [
          "Một chỗ duy nhất để nhìn mọi bản báo giá doanh nghiệp đang nằm chờ, thay vì mở từng đơn đi tìm.",
          "Con số cạnh tiêu đề khối là lượng việc đang tồn — nhìn con số đó mỗi ngày là biết khâu này có đang ùn không.",
          "Lọc theo nấc để tách phần việc đang chờ chính mình ra khỏi phần đang chờ người khác.",
          "Dòng chữ nhạt trên mỗi thẻ ghi giờ gửi: bản có giờ gửi từ mấy hôm trước là dấu hiệu đang kẹt, nên hỏi lại.",
          "Mấy gạch đầu dòng lý do cho thấy nhóm bản nào hay phải chờ nhất — dùng để chỉnh bảng giá cho bớt việc, thay vì xử tay mãi.",
          'Muốn xem kỹ hay chốt thì bấm "Mở để xét"; màn này cố ý không chốt được để không ai chốt nhầm lúc lướt danh sách.',
        ],
        troubles: [
          "Số bản bạn thấy khác số người khác báo: mỗi người xem theo cơ sở của mình, đối chiếu cùng một cơ sở trước khi kết luận thiếu bản.",
          "Danh sách dài bất thường: lọc theo từng nấc để biết đang ùn ở nấc nào rồi hãy hỏi.",
        ],
      },
    ],
    askWho: "Bản nào chưa rõ nên chốt thế nào thì hỏi quản lý trực tiếp trước khi bấm.",
  },
};
